/* Size guide modal state: landing/tabs view, active tab, cm/in unit.
 * All rendering is CSS keyed off the element's `view` and `unit` attributes
 * (see snippets/size-guide.liquid). The element lives inside a <dialog>
 * owned by the theme's hdt-modal component, which handles open/close. */
(() => {
  'use strict';
  if (customElements.get('hdt-size-guide')) return;

  const UNIT_KEY = 'sizeGuideUnit';

  class SizeGuide extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      let unit = 'cm';
      try {
        unit = localStorage.getItem(UNIT_KEY) || 'cm';
      } catch (e) { /* storage unavailable */ }
      this.setUnit(unit === 'in' ? 'in' : 'cm', false);

      this.addEventListener('click', (e) => this._onClick(e));
      const tablist = this.querySelector('[role="tablist"]');
      if (tablist) tablist.addEventListener('keydown', (e) => this._onKeydown(e));

      // Every open starts back on the landing view.
      const dialog = this.closest('dialog');
      if (dialog) dialog.addEventListener('close', () => this._reset());
    }

    _onClick(e) {
      const card = e.target.closest('[data-sg-open]');
      if (card) {
        this.setAttribute('view', 'tabs');
        this.selectTab(card.getAttribute('data-sg-open'));
        return;
      }
      const tab = e.target.closest('[data-sg-tab]');
      if (tab) {
        this.selectTab(tab.getAttribute('data-sg-tab'));
        tab.focus();
        return;
      }
      const unitBtn = e.target.closest('[data-sg-unit]');
      if (unitBtn) this.setUnit(unitBtn.getAttribute('data-sg-unit'), true);
    }

    _onKeydown(e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const tabs = [...this.querySelectorAll('[data-sg-tab]')];
      const current = tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      if (current === -1) return;
      e.preventDefault();
      const delta = e.key === 'ArrowRight' ? 1 : -1;
      const next = tabs[(current + delta + tabs.length) % tabs.length];
      this.selectTab(next.getAttribute('data-sg-tab'));
      next.focus();
    }

    selectTab(name) {
      this.querySelectorAll('[data-sg-tab]').forEach((tab) => {
        const active = tab.getAttribute('data-sg-tab') === name;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      this.querySelectorAll('[data-sg-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-sg-panel') !== name;
      });
      this.scrollTop = 0;
    }

    setUnit(unit, persist) {
      this.setAttribute('unit', unit);
      this.querySelectorAll('[data-sg-unit]').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-sg-unit') === unit ? 'true' : 'false');
      });
      if (persist) {
        try {
          localStorage.setItem(UNIT_KEY, unit);
        } catch (e) { /* storage unavailable */ }
      }
    }

    _reset() {
      this.setAttribute('view', 'landing');
      this.scrollTop = 0;
    }
  }

  customElements.define('hdt-size-guide', SizeGuide);
})();
